import { styled } from '@mui/material/styles';

export const StyledRow = styled('div', {
  shouldForwardProp: (prop) => !['isMobile', 'disabled'].includes(prop),
})(({ theme, isMobile, disabled }) => ({
  borderBottom: disabled ? 'none' : `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  position: 'relative',
  width: 'calc(100% - 16px)',

  '&:hover': {
    cursor: disabled ? 'default' : 'pointer',
    backgroundColor: disabled ? 'transparent' : theme.palette.action.disabledBackground,
    pointerEvents: disabled ? 'none' : undefined,
  },

  '& .firstRow': {
    marginBottom: theme.spacing(0.5),
  },

  '& .secondRow': {
    marginLeft: isMobile ? 0 : 8,
    marginTop: isMobile ? theme.spacing(3) : 0,
  },

  '& .col': {
    width: isMobile ? '33%' : '20%',
  },

  '& .progBar': {
    width: isMobile ? 'auto' : '20%',
    left: 'auto',
    position: isMobile ? 'relative' : 'absolute',
    right: isMobile ? 0 : 8,
    top: isMobile ? 0 : 30,
  },
}));
